import { type ArticleCardProps } from '3-components/Cards/CardArticle/CardArticle';
import { resolveArticlePagesToArticleCards, type ArticlePages, type ArticleCardResolverSettings } from './articleCardResolver';


interface ArticleListingData {
    total: number;
    items: ArticleCardProps[];
}

export const resolveArticleListing = (data: ArticleListingData, settings: ArticleCardResolverSettings): ArticleListingData | null => {
    const { items, total } = data;

    return {
        total: Number(total),
        items: resolveArticlePagesToArticleCards(items as ArticlePages[], settings),
    };
};
